var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix bshadow0 pbs icon-font"},[_c('span',{class:`${_vm.name} ${_vm.color && 'custom-color'} ${_vm.defaultSize && 'custom-size'}`,style:({
      ...(_vm.color ? { '--icon-color': _vm.color } : {}),
      ...(_vm.defaultSize ? { '--icon-size': _vm.defaultSize } : {}),
    })},_vm._l((_vm.path),function(index){return _c('span',{key:index},[_c('span',{class:`path${index} ${_vm.defaultSize && 'custom-size'}`,style:({
          ...(_vm.defaultSize ? { '--icon-size': _vm.defaultSize } : {}),
        })})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }